module.exports = __webpack_public_path__ + "img/youtubeicon_.a439141d.svg";